import React from "react";
import { VStack, Skeleton } from "@chakra-ui/react";

export default function Shimmer({ rows = 4, rowHeight = 16, gap = 3 }) {
  const items = Array.from({ length: rows });
  return (
    <VStack align="stretch" spacing={gap}>
      {items.map((_, idx) => (
        <Skeleton key={idx} height={`${rowHeight}px`} borderRadius="md" />
      ))}
    </VStack>
  );
}
